import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VolcanoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"volcano"}/>
}
